import { Table } from 'react-bootstrap';
import styled from 'styled-components';
import { useDenominaciones } from '../../../../../../appStore/denominaciones';
import { PuestoRow } from './PuestoRow';
import { usePuestoTableConfig } from './PuestosTableProvider';

const Scrollable = styled.div`
  overflow: auto;
  max-height: 500px;
`;

export const MainTable = () => {
  const { withBases, withGrilla, showBotonesActions } = usePuestoTableConfig();
  const { dataPublico } = useDenominaciones();

  // const isUser = useCheckRoles([ROLES.USER]);
  // const esMasQueUser = useCheckRoles([ROLES.LEGALES, ROLES.COMITE, ROLES.DIRECTOR]);

  return (
    <>
      <Scrollable>
        <Table bordered hover size="sm">
          <thead>
            <tr>
              <th className="text-center align-middle">Ubicación Estructural - Dependencia</th>
              <th className="text-center align-middle">Denominación del Puesto</th>
              <th className="text-center align-middle">Nivel</th>
              <th className="text-center align-middle">Agrupamiento</th>
              <th className="text-center align-middle">Reserva Ley N° 22.431</th>
              <th className="text-center align-middle">Capac. Terc.</th>
              <th className="text-center align-middle">Func. Especif.</th>
              <th className="text-center align-middle">Cantidad</th>
              {showBotonesActions && <th className="text-center align-middle">Acciones</th>}
              {/* {withGrilla && <th className="text-center align-middle">Grilla</th>} */}
              {withBases && <th className="text-center align-middle">Ver bases</th>}
              {/* {isUser && !esMasQueUser && <th className="text-center align-middle">Inscribirme</th>} */}
            </tr>
          </thead>

          <tbody>
            {dataPublico?.map((puesto, i) => {
              let puesto2 = {
                //spread operator, expande un objeto dentro de otro
                ...puesto,
                idLlamadoConcurso: 0,
              };
              return <PuestoRow key={`${puesto.idPuesto}`} {...puesto2} />;
            })}
          </tbody>
        </Table>
      </Scrollable>
    </>
  );
};
